import { render, staticRenderFns } from "./PrizeList.vue?vue&type=template&id=07eadcc9&scoped=true&"
import script from "./PrizeList.vue?vue&type=script&lang=js&"
export * from "./PrizeList.vue?vue&type=script&lang=js&"
import style0 from "./PrizeList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PrizeList.vue?vue&type=style&index=1&id=07eadcc9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eadcc9",
  null
  
)

export default component.exports